var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.119,
    height: 29.516,
    viewBox: "0 0 22.119 29.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2536"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 885",
    d: "M168.048 150.931v12.518a2.06 2.06 0 0 1-1.544 2.121 2.883 2.883 0 0 1-.689.077c-5.877 0-11.754-.006-17.63.01a2.181 2.181 0 0 1-2.254-2.257q.032-12.5 0-25.007a2.179 2.179 0 0 1 2.259-2.251c5.877.017 11.753.006 17.63.008a2.086 2.086 0 0 1 2.18 1.657 3.262 3.262 0 0 1 .043.664q.007 6.229.005 12.46zm-15.277 7.669a8.764 8.764 0 0 0 9.984-14.282 8.761 8.761 0 0 0-13.055 11.457c-.31.241-.626.478-.933.727a2.184 2.184 0 0 0-.837 2.318 2.118 2.118 0 0 0 1.716 1.694 2.176 2.176 0 0 0 2.29-.845c.282-.355.558-.716.835-1.069zm7.913 6.129c1.452 0 2.9.01 4.355 0a1.616 1.616 0 1 0-.095-3.228h-8.535a2.5 2.5 0 0 0-.4.035 1.611 1.611 0 0 0 .325 3.193c1.447.003 2.899-.003 4.35-.003zm-10.6-26.04a1.609 1.609 0 1 0-1.6 1.617 1.618 1.618 0 0 0 1.596-1.62zm17.046.008a1.609 1.609 0 1 0-1.606 1.609 1.611 1.611 0 0 0 1.602-1.612zm-17.05 24.415a1.609 1.609 0 1 0-1.6 1.613 1.618 1.618 0 0 0 1.6-1.613z",
    transform: "translate(-145.93 -136.142)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 886",
    d: "m191.867 240.236.655-.848c.592-.765 1.192-1.525 1.772-2.3a.383.383 0 0 1 .455-.165 3.677 3.677 0 0 0 1.669-7.16 3.468 3.468 0 0 0-3.718 1.165 3.568 3.568 0 0 0-.593 3.858c.035.088.078.174.127.281l-1.652 1.279-1.626 1.259a7.843 7.843 0 1 1 2.912 2.631z",
    transform: "translate(-184.421 -218.561)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 887",
    d: "M255.511 296.456c.465-.837.483-1.4-.009-1.837-.8-.71-1.493-.3-2.14.284a2.712 2.712 0 0 1 .619-3.2 2.766 2.766 0 0 1 4.34 3.263 2.687 2.687 0 0 1-2.81 1.49z",
    transform: "translate(-244.774 -278.991)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 888",
    d: "M182.833 351.107a1.283 1.283 0 0 1 .476-1.084q3.124-2.432 6.257-4.852a.335.335 0 0 1 .493 0c.163.164.111.328-.017.491q-1.847 2.367-3.69 4.736c-.391.5-.761 1.025-1.165 1.517a1.25 1.25 0 0 1-1.33.435 1.281 1.281 0 0 1-.974-.937 1.814 1.814 0 0 1-.05-.306z",
    transform: "translate(-179.975 -328.877)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 889",
    d: "M276 476.707h-4.3a.69.69 0 0 1-.722-.92.654.654 0 0 1 .528-.444 1.958 1.958 0 0 1 .347-.02h8.421a.7.7 0 1 1-.008 1.385q-2.132.001-4.266-.001z",
    transform: "translate(-261.252 -449.048)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 890",
    d: "M171.2 160.828a.687.687 0 1 1-.687-.677.682.682 0 0 1 .687.677z",
    transform: "translate(-167.98 -158.291)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 891",
    d: "M389.986 160.824a.682.682 0 0 1 .692-.673.69.69 0 0 1 .681.687.687.687 0 1 1-1.373-.014z",
    transform: "translate(-371.081 -158.292)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 892",
    d: "M171.207 476.058a.682.682 0 0 1-.673.692.69.69 0 1 1 .673-.692z",
    transform: "translate(-167.982 -449.094)",
    style: {
      fill: "#0045db",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdd);
export default __webpack_public_path__ + "static/media/hdd.163803da731f92ddd3701f0e57ae02e3.svg";
export { ForwardRef as ReactComponent };